import React, { useEffect } from "react";
import styled from "styled-components";
import Task from "./Task";
import { Droppable } from "react-beautiful-dnd";
import { transformToTasks } from "../../../../helpers";

const Container = styled.div`
  margin: 8px;
  border: 2px solid lightgray;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
`;
const Title = styled.h3`
  padding: 8px;
`;
const TaskList = styled.div`
  padding: 8px;
  flex-grow: 1;
  background-color: "white";
`;
export default function (props) {
  const { column, tasks, id, filters, refreshWorks } = props;

  useEffect(() => {
    console.log("tasks inside column ===>", tasks, column.tasksIds);

    console.log("column", props.column, props.tasks);
  }, []);
  return (
    <Container>
      <Title>
        {" "}
        {column.title}{" "}
        {column.id !== "column-8" && "( " + column.tasksIds.length + " )"}
      </Title>
      <Droppable droppableId={column.id}>
        {(provided) => (
          <TaskList ref={provided.innerRef} {...provided.droppableProps}>
            {tasks.map((task, index) => (
              <Task key={task?.id} task={task} index={index} />
            ))}
            {provided.placeholder}
          </TaskList>
        )}
      </Droppable>
    </Container>
  );
}
